import { useMutation, useQueryClient } from 'react-query'
import { useSvcCompareVersionsContext } from '@dc-shared-web/providers'
import { Note } from '@dc-shared-web/hooks/api/comparison/types'
import { updateChangeNote } from '@dc-shared-web/hooks/api/comparison/updateChangeNote'
import { COMPARISON_DATA_QUERY_KEY } from '@dc-shared-web/hooks/api/queryKeys'

interface UpdateChangeNoteMutationParams {
  changeUuid: string
  noteUuid: string
  content: string
  updated_by: string
}

export const useUpdateChangeNote = () => {
  const svcCompareVersionApiClient = useSvcCompareVersionsContext()
  const queryClient = useQueryClient()

  return useMutation<Note, Error, UpdateChangeNoteMutationParams>({
    mutationFn: ({ changeUuid, noteUuid, content, updated_by }) =>
      updateChangeNote(svcCompareVersionApiClient, changeUuid, noteUuid, {
        content,
        updated_by,
      }),
    onSuccess: () => {
      // Invalidate comparison data queries to refetch with updated notes
      queryClient.invalidateQueries([COMPARISON_DATA_QUERY_KEY])
    },
  })
}
